import { z } from 'zod';

import { createListApiSchema } from '../General/schemas';

export const badgeSchema = z
	.object({
		id: z.string(),
		badgeUID: z.string().optional(),
		enabled: z.boolean().optional(),
		userSecret: z.string().optional(),
		userId: z.string().optional(),
		userPassword: z.string().optional(),
	})
	.describe('Badge');

export const badgesApiResponseSchema = createListApiSchema(badgeSchema).describe('Badges');
